<template>
  <div class="reference-list-item">
    <div
      class="reference-list-item__remove"
      :class="{ show: showingDeleteConfirmation }"
    >
      <div v-if="showingDeleteConfirmation">
        <span>Are you sure you want to remove this reference?</span>

        <div>
          <button @click="denyDelete" class="text-button">
            No
          </button>
          <button @click="confirmDelete" class="text-button">
            Yes
          </button>
        </div>
      </div>
      <font-awesome-icon
        @click="promptDeleteConfirmation"
        v-else
        icon="trash"
        class="icon"
        size="2x"
      />
    </div>

    <figure class="reference-list-item__figure">
      <img class="reference-list-item__image" :src="image" :alt="title" />
    </figure>
  </div>
</template>

<script>
import maddyApi from '@/services/maddyApi';
export default {
  name: 'reference-list-item',
  props: ['image', 'title', 'url', 'id'],
  data() {
    return {
      showingDeleteConfirmation: false,
    };
  },
  methods: {
    promptDeleteConfirmation() {
      this.showingDeleteConfirmation = true;
    },
    denyDelete() {
      this.showingDeleteConfirmation = false;
    },
    confirmDelete() {
      // TODO: Delete reference
      maddyApi
        .delete(`/studies/${this.$route.params.id}/reference/${this.id}`)
        .then(() => {
          this.$emit('removed');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.reference-list-item {
  position: relative;

  &__remove {
    opacity: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    background: rgba(0, 0, 0, 0.6);
    color: white;
    border-radius: 2px;
    transition: all 64ms ease-in-out;
    text-align: center;

    &.show {
      opacity: 1;
    }
  }

  .icon {
    cursor: pointer;
  }

  &:hover {
    .reference-list-item__remove {
      opacity: 1;
    }
  }
}
.reference-list-item__figure {
  margin: 0;
  display: flex;
  flex: 1;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    max-height: 125px;
    object-fit: cover;
    vertical-align: bottom;
  }
}
</style>
